<template>
<div :class="'chats page'">

	<maincontent>
		<template v-slot:content>

			<linepreloader v-if="loading"/>

			<chats v-else/>


		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>

</style>

<script>
import chats from "@/components/modules/chats/index.vue";
import f from "@/application/shared/functions.js";

export default {
	name: 'chats_page',
	components: {
		chats
	},

	data : function(){
		return { 
			loading : false,
		}
	},

	computed: {

	},

	methods: {
		
		load : function(){
			
		}
	},

	watch: {
	},

	mounted() {
		
	}
}
</script>
